module.exports = __webpack_public_path__ + "static/OneDotCd-BoldItalic.6782c797.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-BoldItalic.woff2
// module id = 743
// module chunks = 114276838955818